import { createRequestActionTypes } from '../../helpers'

export const FETCH_ADMIN_LINKS = createRequestActionTypes(
  'LAUNCH_PAD',
  'FETCH_ADMIN_LINKS'
)
export const ADD_USER_LINK = createRequestActionTypes(
  'LAUNCH_PAD',
  'ADD_USER_LINK'
)
export const UPDATE_USER_LINK = createRequestActionTypes(
  'LAUNCH_PAD',
  'UPDATE_USER_LINK'
)
export const DELETE_USER_LINK = createRequestActionTypes(
  'LAUNCH_PAD',
  'DELETE_USER_LINK'
)
export const FETCH_USER_LINKS = createRequestActionTypes(
  'LAUNCH_PAD',
  'FETCH_USER_LINKS'
)
